export default "__VITE_ASSET__CpY$1Ont__"